module.exports = __webpack_public_path__ + "assets/empty-ellipse.e9811dbb.svg";